import React, { Component } from 'react';
import uuid from 'uuid';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as needRefresh from '../../../../../actions/needRefresh';

import Message from '../../../../Message';

import { Box } from '../style';
import { ContainerRegistry } from './style';
import api from '../../../../../services/api';

class Registry extends Component {
	state = {
		fade: true,
		logs: [],
	};

	componentDidMount() {
		return this.requestDemand();
	}

	shouldComponentUpdate(nextProps, nextState) {
		if (nextProps.refresh.refresh) {
			return this.requestDemand();
		}

		return nextState;
	}

	requestDemand = async () => {
		// eslint-disable-next-line no-shadow
		const { demandId, needRefresh } = this.props;

		needRefresh(false);

		const response = await api.get(`/demands/${demandId}/logs`);

		return this.setState({
			logs: response.data.data,
		});
	};

	handleFade = () => {
		this.setState({
			fade: false,
		});
	};

	render() {
		const { fade, logs } = this.state;

		if (logs.length > 0) {
			return (
				<Box borderRadius="8px 8px 8px 8px" className="mt-3" padding="16px">
					<ContainerRegistry>
						<h3 className="title title-registry mb-3">Registros:</h3>

						<div className={`panel-wrapper ${fade ? 'show' : null}`}>
							<div className="panel">
								{logs && logs.map(log => (
									<Message content={log} key={uuid.v4()} />
								))}
							</div>
						</div>
					</ContainerRegistry>
					<div className={`controller-fade-panel ${fade ? 'show' : null}`}>
						<button type="button" onClick={this.handleFade}>Mostrar mais +</button>
					</div>
					<div className={`fade-panel ${fade ? 'show' : null}`} />
				</Box>
			);
		}

		return null;
	}
}

const mapStateToProps = state => ({
	refresh: state.needRefresh,
});

const mapDispatchToProps = dispatch => bindActionCreators(needRefresh, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Registry);
